module.exports = __webpack_public_path__ + "static/media/elon.9d887e67.svg";